module.exports = __webpack_public_path__ + "img/title.c77058af.png";